// Delta-line helpers for the dashboard KPI tiles (E13-S2 / #243).

export type DeltaTone = "good" | "bad" | "neutral";

// Renders the value exactly as the endpoint gives it (already rounded to two
// decimals server-side), with an explicit "+" on increases. Negative values
// carry their own minus sign; zero renders unsigned.
export const formatDeltaPct = (deltaPct: number): string => {
    const sign = deltaPct > 0 ? "+" : "";

    return `${sign}${deltaPct}% vs prior`;
};

// Which way is "green" depends on the tile: for ordersPlaced an increase is
// good; the story flips ordersShipped / itemsLowStock / issuesFound so a
// decrease is good there. Zero movement is neutral either way.
export const deltaTone = (
    deltaPct: number,
    positiveIsGood: boolean,
): DeltaTone => {
    if (deltaPct === 0) {
        return "neutral";
    }

    return deltaPct > 0 === positiveIsGood ? "good" : "bad";
};
